import * as React from "react"
const SvgRecommendationIncomingOnly = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.87 9.116q-2.9-1.674-6.097-.836t-4.872 3.74l-.087.151-.33-1.23a.95.95 0 0 0-.468-.588.95.95 0 0 0-.744-.111.95.95 0 0 0-.588.468.95.95 0 0 0-.112.744l.952 3.552a.96.96 0 0 0 .456.61.96.96 0 0 0 .756.09l3.551-.952a.95.95 0 0 0 .588-.469.95.95 0 0 0 .112-.743.95.95 0 0 0-.469-.589.95.95 0 0 0-.743-.111l-1.23.329.088-.152q1.25-2.164 3.65-2.799t4.588.628q.346.201.657.437.31.237.573.533.305.32.705.379.4.057.76-.168a.9.9 0 0 0 .426-.663.87.87 0 0 0-.252-.737 6.4 6.4 0 0 0-.874-.837 8 8 0 0 0-.995-.676" />
  </svg>
)
export default SvgRecommendationIncomingOnly
